import React from 'react'

const Spinner = () => {
  return (
    <div>
        <img className='d-block m-auto' style={{width:"80px"}} src="https://media3.giphy.com/media/L05HgB2h6qICDs5Sms/200w.webp?cid=ecf05e47zdr0igggfygy5rx2j63l8516j523tzumf9mykv6j&rid=200w.webp&ct=s" alt="" />
    </div>
  )
}

export default Spinner